import { render, staticRenderFns } from "./PlaidWaiting.vue?vue&type=template&id=5ffb229c&scoped=true"
import script from "./PlaidWaiting.vue?vue&type=script&lang=js"
export * from "./PlaidWaiting.vue?vue&type=script&lang=js"
import style0 from "./PlaidWaiting.vue?vue&type=style&index=0&id=5ffb229c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb229c",
  null
  
)

export default component.exports